type FormatDateOptions = {
  isUpperCase?: boolean;
  locale?: Intl.LocalesArgument;
  format?: Intl.DateTimeFormatOptions;
};

const DEFAULT_FORMAT: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
};

const DEFAULT_LOCALE: Intl.LocalesArgument = 'en-US';

const formatDateWithOptions = (
  date: string | Date,
  options: FormatDateOptions = {
    isUpperCase: false,
    locale: DEFAULT_LOCALE,
  },
) => {
  if (!date) {
    return null;
  }

  const formatOptions = options.format ? { timeZone: 'UTC', ...options.format } : DEFAULT_FORMAT;
  const formattedDate = new Date(date).toLocaleDateString(options.locale, formatOptions);

  if (options.isUpperCase) {
    return formattedDate.toUpperCase();
  }

  return formattedDate;
};

const formatTimestamp = (timestamp: string | Date) => {
  return formatDateWithOptions(timestamp, {
    format: {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'UTC',
    },
  });
};

const formatDate = (date: string | Date, isUpperCase: FormatDateOptions['isUpperCase'] = true) => {
  return formatDateWithOptions(date, {
    isUpperCase,
    format: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    },
  });
};

const formatDateShort = (date: string | Date) => {
  return formatDateWithOptions(date, {
    format: {
      year: 'numeric',
      month: 'long',
      timeZone: 'UTC',
    },
  });
};

const formatDateYear = (date: string | Date) => {
  return formatDateWithOptions(date, {
    format: {
      year: 'numeric',
      timeZone: 'UTC',
    },
  });
};

export { formatDateWithOptions, formatDateYear, formatDateShort, formatDate, formatTimestamp };
